/** English ordinal for day of month: 1st, 2nd, 3rd, 4th, … */
function dayWithOrdinal(day: number): string {
  if (day >= 11 && day <= 13) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

function parseIsoDateParts(
  iso: string | null | undefined,
): { day: number; month: number; year: number } | null {
  if (iso == null || typeof iso !== "string") return null;
  const t = iso.trim();
  if (!t) return null;

  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(t);
  if (!m) return null;

  const year = Number(m[1]);
  const month = Number(m[2]) - 1;
  const day = Number(m[3]);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day))
    return null;

  const d = new Date(Date.UTC(year, month, day));
  if (
    d.getUTCFullYear() !== year ||
    d.getUTCMonth() !== month ||
    d.getUTCDate() !== day
  ) {
    return null;
  }
  return { day, month, year };
}

/**
 * e.g. `2025-03-29` → `29th March` (en-GB long month, UTC calendar date).
 */
export function formatIsoDateOrdinalMonth(
  iso: string | null | undefined,
): string | null {
  const parts = parseIsoDateParts(iso);
  if (!parts) return null;
  const { day, month, year } = parts;
  const monthName = new Date(Date.UTC(year, month, 1)).toLocaleDateString(
    "en-GB",
    { month: "long", timeZone: "UTC" },
  );
  return `${dayWithOrdinal(day)} ${monthName}`;
}

/**
 * e.g. `2025-03-29` … `2025-03-31` → `29th March - 31st March`.
 * Cross-month ranges: `29th March - 2nd April`.
 */
export function formatIsoDateRangeOrdinalMonth(
  startIso: string | null | undefined,
  endIso: string | null | undefined,
): string | null {
  const start = formatIsoDateOrdinalMonth(startIso);
  const end = formatIsoDateOrdinalMonth(endIso);
  if (!start || !end) return null;
  return `${start} - ${end}`;
}
